// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Users_wrapper__1yxFD","label":"Users_label__1vJ_-","allUsers":"Users_allUsers__q7cCr","show":"Users_show__28oy2","content":"Users_content__1gFH2"};